<div class="banner-secundario-mypath">
	<div id="carousel-mypath" class="carousel slide" data-bs-ride="carousel">
		<div class="carousel-inner" style="display: block; height: 100%;">
			<div class="carousel-item active">
				<img [src]="imagenBanner">
				<div class="  ">
					<div class="carousel-caption text-start">
						<img src="assets/img/servicios-especializados/mypath/Mypath_Logo.png" class="logo-mypath">
						<br class="d-none d-sm-block"><br class="d-none d-sm-block">
						<h1 [innerHtml]="texto"></h1>
						<br class="d-none d-sm-block">
						<p><a class="btn btn-lg btn-primary" href="/servicios-especializados/mypath" target="_blank">Saber más</a></p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>